import type { Icon } from '@phosphor-icons/react'
import {
  ChartLineUp,
  ChatsCircle,
  ClockCounterClockwise,
  Flag,
  CookingPot,
  CurrencyKrw,
  Factory,
  Flask,
  Gear,
  Medal,
  Megaphone,
  Package,
  Receipt,
  SealCheck,
  ShieldCheck,
  Users,
} from '@phosphor-icons/react'

export interface NavItem {
  path: string
  label: string
  icon: Icon
  /** 사이드바에 미처리 건수 배지를 붙일 항목 */
  badge?: 'quotes'
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

/** 사이드바 메뉴. 새 화면은 여기와 routes.tsx 에 같이 추가한다. */
export const NAV: NavGroup[] = [
  {
    label: '운영',
    items: [
      { path: '/dashboard', label: '대시보드', icon: ChartLineUp },
      { path: '/quotes', label: '견적 요청', icon: Receipt, badge: 'quotes' },
      { path: '/factories', label: '공장 목록', icon: Factory },
      { path: '/expert-reviews', label: '전문가 검수', icon: SealCheck },
      { path: '/manufacturing', label: '공장 관리', icon: CookingPot },
      { path: '/samples', label: '샘플 거래', icon: Package },
      { path: '/users', label: '사용자', icon: Users },
      { path: '/notify', label: '공지 발송', icon: Megaphone },
    ],
  },
  {
    label: '콘텐츠',
    items: [
      { path: '/simulations', label: '시뮬레이션', icon: Flask },
      { path: '/community', label: '커뮤니티', icon: ChatsCircle },
      { path: '/reports', label: '신고 대기열', icon: Flag },
      { path: '/cases', label: '완성 사례', icon: CookingPot },
    ],
  },
  {
    label: 'AI 데이터',
    items: [
      { path: '/golden-set', label: '골든셋', icon: Medal },
      { path: '/prices', label: '재료 단가', icon: CurrencyKrw },
    ],
  },
  {
    label: '수익',
    items: [{ path: '/ads', label: '광고 관리', icon: Megaphone }],
  },
  {
    label: '설정',
    items: [
      { path: '/settings', label: '설정', icon: Gear },
      { path: '/audit', label: '작업 기록', icon: ClockCounterClockwise },
      { path: '/access-grants', label: '권한 관리', icon: ShieldCheck },
    ],
  },
]
